import { RouteType } from "types/RouteType";
// import jobDashboardRoute from "./JobDashboard/jobDashboard.Route";
import projectDashboardRoute from "./ProjectDashboard/ProjectDashboard.Route";
import jobGanttChartRoute from "./JobGanttChart/JobGanttChart.Route";

// Project management for commercial and large residential projects
// Removed precast-specific modules: JobPanelCounts, PCS

const projectManagementRoutesList: RouteType[] = [
    // ...jobDashboardRoute,
    ...projectDashboardRoute, // Project dashboard for commercial/large residential projects
    ...jobGanttChartRoute, // Gantt chart for project scheduling and delivery planning
];

export default projectManagementRoutesList;
